import { render, staticRenderFns } from "./EditarUsuarioPorUG.vue?vue&type=template&id=88813b8e&scoped=true"
import script from "./EditarUsuarioPorUG.vue?vue&type=script&lang=ts"
export * from "./EditarUsuarioPorUG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88813b8e",
  null
  
)

export default component.exports